$('.newsletter-form').each(function() {
	$(this).on('submit-callback', (event, data) => {
		const callout = $(this).children('.callout');
        const msg = callout.children('.callout-message');

		// If error
		if (data['error']) {
			callout.removeClass(['success', 'hide']);
			callout.addClass('alert');
            msg.text(data.message);
		}
		// If success
		else {
			callout.removeClass(['alert', 'hide']);
			callout.addClass('success');
            msg.text(data.message);
		}
	});
});
